import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useBilling } from "@/contexts/BillingContext";
import { BILLING } from "@/constants/testIds";
import { XCircle, Loader2, ArrowLeft, ExternalLink } from "lucide-react";
import { toast } from "sonner";

export default function BillingCancel() {
  const { startCheckout, billing, paymentsBlockedInTWA } = useBilling();
  const [loading, setLoading] = useState(false);

  const retry = async () => {
    setLoading(true);
    try {
      await startCheckout();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not start checkout");
      setLoading(false);
    }
  };

  return (
    <div
      data-testid={BILLING.cancelScreen}
      className="border-t border-border min-h-[70vh] flex items-center justify-center px-6 py-16"
    >
      <div className="max-w-xl w-full bg-card border border-border p-10 lg:p-14 text-center">
        <XCircle className="w-12 h-12 text-muted-foreground mx-auto mb-6" />
        <div className="sux-marker mb-3">Checkout cancelled</div>
        <h1 className="text-3xl md:text-4xl font-black tracking-tight mb-4" style={{ fontFamily: "Outfit" }}>
          No worries — you weren&apos;t charged.
        </h1>
        <p className="text-muted-foreground text-sm mb-8">
          Whenever you&apos;re ready, credit packs start at €{(billing?.packs?.[0]?.amount ?? 2).toFixed(2)} for 20 summaries — no subscription.
        </p>
        <div className="flex flex-col gap-3">
          <button
            onClick={retry}
            disabled={loading}
            data-testid={BILLING.cancelRetry}
            className="w-full bg-[#002FA7] text-white font-mono uppercase tracking-[0.25em] text-[11px] py-4 hover:bg-[#00227A] transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
          >
            {loading ? (
              <>
                <Loader2 className="w-3 h-3 animate-spin" /> Redirecting…
              </>
            ) : paymentsBlockedInTWA ? (
              <>
                <ExternalLink className="w-3 h-3" /> Retry payment →
              </>
            ) : (
              <>Retry payment →</>
            )}
          </button>
          <Link
            to="/"
            className="font-mono uppercase tracking-[0.2em] text-[11px] py-3 border border-border hover:bg-secondary transition-colors flex items-center justify-center gap-2"
          >
            <ArrowLeft className="w-3 h-3" /> Back to dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
